import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { MediaCard } from './MediaCard';
import { MediaService } from '../../../services/MediaService';

interface State {
    mediaList: ReqType.Media[];
}

interface Props {
}

/**
 * Ce composant permet d'affichage d'une liste de mediacard
 */
export class MediaList extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            mediaList: [],
        };
        this.getMedia();
    }

    render() {
        var mediaList = this.state.mediaList.map(
            (media: ReqType.Media) => {
                return (
                    <MediaCard
                        media={media}
                        key={media.id}
                    />
                );
            }
        );
        return (
            <div style={{paddingTop: '20px', paddingBottom: '20px'}}>
                {mediaList}
            </div>
        );
    }

    private getMedia() {
        MediaService.getInstance().getMediaList().then(
            (mediaList: ReqType.Media[]) => {
                var arr = mediaList.sort(
                    (a: ReqType.Media, b: ReqType.Media) => {
                        return (Number.parseInt(b.created_at) - Number.parseInt(a.created_at));
                    }
                );
                this.setState({
                    mediaList: arr
                });
            }
        );
    }
} 


// WEBPACK FOOTER //
// ./src/components/MediasPage/internalComponents/MediaList.tsx